import posthog, { type PostHog } from 'posthog-js';
import { type UserProfile } from '@/types';
import { POSTHOG_API_KEY, POSTHOG_DEV, POSTHOG_HOST } from '@/types/environment';
import { isDev, isFeatureTest, isTest } from '@/utils/helpers';

const mockPosthog: PostHog = {
  isFeatureEnabled: (featureKey: string): boolean => {
    console.log(`Mock isFeatureEnabled called with featureKey: ${featureKey}`);
    return window.localStorage.getItem(featureKey) === 'true';
  },
  reset: (): void => {
    console.log('Mock reset called');
  },
  identify: (distinctId: string, properties?: object) => {
    console.log(`Mock identify called with distinctId: ${distinctId} and properties:`, properties);
  },
} as PostHog;

let posthogInstance: PostHog;

if (isTest || isFeatureTest || (isDev && POSTHOG_DEV === '')) {
  posthogInstance = mockPosthog;
} else {
  posthogInstance = posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
  }) as PostHog;
}

const posthogSetup = (userProfile: UserProfile) => {
  const { company_schema_name, id, email, full_name } = userProfile;
  const uniqueId = `${POSTHOG_DEV}${company_schema_name}-${id}`;

  posthogInstance.identify(uniqueId, {
    company_schema_name,
    email,
    full_name,
    dev_name: POSTHOG_DEV,
  });
};

export { posthogInstance, posthogSetup };
